import styled from "styled-components";
import {
  space,
  color,
  height,
  borders,
  position,
  textAlign,
  background,
} from "styled-system";

export const Background = styled.section`
  background-size: cover;
  background-position: 50% 50%;
  ${space};
  ${color};
  ${height};
  ${borders};
  ${position};
  ${textAlign};
  ${background};
`;
